// add an slight delay to requestAnimationFrame
const requestAnimationFrame = function(fn) {
	return window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
}

// note: ie11 or jquery do not support classList/addClass on svg elements - manipulate class attribute directly
const addSvgClass = function( node, className ) {
	let nodeClass = `${node.getAttribute('class')} ${className}`;
	node.setAttribute( 'class', nodeClass );

	return nodeClass;
}

const removeSvgClass = function( node, className ) {
	let nodeClass = node.getAttribute('class').replace( ( new RegExp( `\\b${className}\\b`) ), '' ).trim();
	node.setAttribute( 'class', nodeClass );

	return nodeClass;
}

class MapState {
	constructor( map, node ) {
		this.map  = map;
		this.node = node;

		this.detail            = document.createElement( 'div' );
		this.detail.className  = 'state-profiles-map__detail';
		this.detailActiveClass = 'state-profiles-map__detail--active';
		this.activeClass       = 'state-profiles-map__state--active';
		this.active            = false;

		this.resetCoords();

		this.key    = this.node.getAttribute('abbr');
		this.status = this.node.getAttribute('status');

		if ( 'active' === this.status ) {
           
			this.node.addEventListener( 'click', (e) => {
				if ( this.active ) {
					this.map.deactivate( this.key );
				} else {
					// set custom coords originating from mouse click and not center of the state
					this.coords = { x: e.clientX, y: e.clientY };

					// on desktop be relative to the map and not fixed
					if ( this.map.getMode() === 'desktop' ) {
						let mapRect = this.map.node.getBoundingClientRect();
						this.coords.x -= mapRect.left;
						this.coords.y -= mapRect.top;
					}

					this.map.activate( this.key );
				}
			} );
		}
	}

	resetCoords() {
		const rect = this.node.getBoundingClientRect();
		
		this.coords = {
			x: rect.left + ( rect.width / 2 ),
			y: rect.top + ( rect.height / 2 ),
		}
	}

	activate() {
		this.template();

		addSvgClass( this.node, this.activeClass );
		
		this.detail.style.left = `${this.coords.x - 20}px`;
		this.detail.style.top = `${this.coords.y - 150}px`;
		this.map.node.appendChild( this.detail );
		requestAnimationFrame(() => {
			this.detail.classList.add( this.detailActiveClass );
			// this.detail.style.top = '';
			// this.detail.style.left = '';
		});

		this.active = true;
	}

	deactivate() {
		this.detail.style.left = `${this.coords.x}px`;
		this.detail.style.top = `${this.coords.y}px`;
		removeSvgClass( this.node, this.activeClass );

		requestAnimationFrame(() => {
			this.detail.classList.remove( this.detailActiveClass );

			let transitionend = (e) => {
				if ( e.target === this.detail && e.propertyName === 'transform' ) {
					this.detail.removeEventListener('transitionend', transitionend);
					this.detail.parentNode.removeChild(this.detail);
				}
			}

			this.detail.addEventListener('transitionend', transitionend);
		});

		this.active = false;
	}

	template() {
		if ( ! this.detail.innerHTML ) {
			const closeDiv = document.createElement('div');
			const close = document.createElement('button');
			close.className = 'state-profiles-map__close';
			close.addEventListener('click', () => this.map.deactivate() );
			close.innerHTML = '&times;';
			closeDiv.appendChild(close);

			this.detail.appendChild(closeDiv);
// window.addEventListener('click', () => this.map.deactivate() );
			const contentDiv = document.createElement('div');
			contentDiv.className = 'state-profiles-map__detail-content';
			this.detail.appendChild(contentDiv);
			if ( this.node.getAttribute('name') ) {
				contentDiv.insertAdjacentHTML( 'beforeend', `<h6>${this.node.getAttribute('name')}</h6>
                                                            <div class="wp-block-button is-style-default map-arrow">
                                                            <a href="/state-profiles/${this.node.getAttribute('abbr').toLowerCase()}" class="wp-block-button__link"><span>Explore</span>
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="svg svg--button-arrows arrow-icon" width="32" height="32" viewBox="0 0 32 32" role="img" focusable="false"><g fill="none" stroke="#2175FF" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10"><circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle><path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path></g></svg>
                                                            </a> </div>` );
                                                            
			}
		}
	}
}

class StateMuniMap {
	constructor( node ) {
		this.node = node;
		this.active = null;
		this.activeClass = 'state-profiles-map--active';
		this.map = this.node.querySelector('svg');
        this.mapContent = this.node.querySelector('.state-map__content');
		this.states = {};
        this.selectHeading = document.createElement('h6');
        this.selectHeading.innerText = "Explore A State";
		this.selectLabel = document.createElement('label');
        
        
		this.selectLabelA11y = document.createElement( 'span' );
		this.selectLabelA11y.className = 'a11y';
		this.selectLabelA11y.innerText = "Select a State";

		this.select = document.createElement('select');
		this.select.className = 'state-profiles-map__select';
		this.select.insertAdjacentHTML( 'afterbegin', '<option value="">Select a State</option>' );
		this.select.addEventListener( 'change', () => {
			if ( this.select.value ) {
				this.states[ this.select.value ].resetCoords();
				this.activate( this.select.value );
			} else {
				this.deactivate();
			}
		} );
        this.selectLabel.appendChild(this.selectHeading);
		this.selectLabel.appendChild(this.selectLabelA11y);
		this.selectLabel.appendChild(this.select);
		this.mapContent.appendChild( this.selectLabel );

		Array.from( this.node.querySelectorAll( '.state-profiles-map__state' ) ).map( state => {
			const abbr = state.getAttribute('abbr');

			if ( state.getAttribute('status') === 'active' ) {
				this.select.insertAdjacentHTML( 'beforeend', `<option value="${abbr}">${state.getAttribute('name')}</option>` );
			}

			this.states[ abbr ] = new MapState( this, state );
		} );

		document.addEventListener('keyup', (e) => {
			if ( this.active !== null && e.key === 'Escape' ) {
				this.deactivate();
			}
		} );

		this._handleResize = () => {
			var width = Math.min( this.map.getAttribute('width'), this.map.parentNode.offsetWidth );
			var height = width * this.map.getAttribute('height') / this.map.getAttribute('width');
			this.map.style.width = width + 'px';
			this.map.style.height = height + 'px';

			if ( this.active ) {
				this.states[ this.active ].resetCoords();
			}
		}

		window.addEventListener('resize', this._handleResize);
		this._handleResize();
	}

	getMode() {
		if ( document.body.clientWidth < 800 ) {
			return 'mobile';
		}

		return 'desktop';
	}

	activate( key ) {
		if ( this.active !== null ) {
			this.states[ this.active ].deactivate();
		}

		if ( this.getMode() === 'mobile' ) {
			document.body.style.overflow = 'hidden';
		}

		this.active = key;
		this.states[ this.active ].activate();
		this.select.value = this.states[ this.active ].key;
		this.node.classList.add(this.activeClass);
	}

	deactivate() {
		if ( this.active !== null ) {
			this.states[ this.active ].deactivate();
			this.node.classList.remove(this.activeClass);
		}

		this.active = null;
		this.select.value = '';
		document.body.style.overflow = '';
	}
}

StateMuniMap.instances = Array.from( document.querySelectorAll( '.state-profiles-map' ) ).map( node => new StateMuniMap( node ) );

export default StateMuniMap;
